
const getFormValues = (form) => {

    // return Array.from(form.elements)
    //     .filter((element) => element.name) // Filter elements that have a `name` attribute
    //     .reduce((acc, element) => {
    //         if (element.type === "radio") {
    //
    //             if (element.checked) {
    //                 acc[element.name] = element.value;
    //             }
    //         } else if (element.type === "checkbox") {
    //
    //             acc[element.name] = acc[element.name] || [];
    //             if (element.checked) {
    //                 acc[element.name].push(element.value);
    //             }
    //         } else {
    //
    //             acc[element.name] = element.value;
    //         }
    //         return acc;
    //     }, {});



    return Array.from(form.elements)
        .filter((element) => element.name)
        .reduce((acc, element) => {
            acc[element.name] = element.value;
            return acc;
        }, {});
};


export default getFormValues;
